export const OEM_ADMIN_SELF_REQUEST = "OEM_ADMIN_SELF_REQUEST";
export const OEM_ADMIN_SELF_SUCCESS = "OEM_ADMIN_SELF_SUCCESS";
export const OEM_ADMIN_SELF_FAILURE = "OEM_ADMIN_SELF_FAILURE";

export const fetchOemAdminSelf = () => async (dispatch) => {
  dispatch({ type: OEM_ADMIN_SELF_REQUEST });
  try {
    const { default: APIManager } = await import(
      "../../../Services/ApiManager/ApiManager"
    );
    const json = await APIManager.getCognitoAdminSelf();
    dispatch({ type: OEM_ADMIN_SELF_SUCCESS, payload: json });
    return json;
  } catch (error) {
    dispatch({ type: OEM_ADMIN_SELF_FAILURE, error });
    throw error;
  }
};